module.exports = __webpack_public_path__ + "static/images/the-order.73952b4f879b92460229fdb9386fc3e6.jpg";